import { Box, Typography, Skeleton } from '@mui/material';
import { StatisticsCard } from '../../@types/statistic';
import StatisticCard from './StatisticCard';
import style from './style';

type Props = {
  loading: boolean,
  statistics: StatisticsCard[],
  title: string,
}

export default function StatisticsBar({
  statistics, title, loading,
}: Props): JSX.Element {
  const renderStatusItem = (): JSX.Element[] => {
    return statistics.map((status) => {
      const {
        title: cardTitle, icon, amount, key,
      } = status;

      if (loading) {
        return (
          <Skeleton
            key={ key }
            width={ style.skelaton.width }
            height={ style.skelaton.height }
            variant={ style.skelaton.variant }
            sx={ style.skelaton.sx }
          />
        );
      }

      return (
        <StatisticCard
          key={ key }
          icon={ icon }
          title={ cardTitle }
          amount={ amount }
        />
      );
    });
  };

  return (
    <Box
      sx={ style.main.sx }
    >
      <Typography
        variant={ style.text.variant }
        sx={ style.text.sx }
      >
        { title }
      </Typography>
      <Box
        sx={ style.cardBox }
      >
        { renderStatusItem() }
      </Box>
    </Box>
  );
}
